<span class="left">{{ isNegative ? '(' : '' }}£{{ leftPart }}</span>
<span class="right">.{{ rightPart }}{{ isNegative ? ')' : '' }}</span>
